<template>
  <b-card
    no-body
    :class="{'open': visible, 'mb-0': true}"
    @mouseenter="collapseOpen"
    @mouseleave="collapseClose"
  >
    <b-card-header

      :class="{'collapsed': !visible, 'cursor-pointer': true}"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="collapseItemID"
      role="tab"
      data-toggle="collapse"
      @click="updateVisible(!visible)"
    >
      <div class="d-flex w-100 justify-content-between">
        <h4 class="card-title py-0 mb-0">
          <span
            v-show="!hideDropdownIcon"
            class="dropdown"
          >
            <feather-icon
              :class="{'open': visible}"
              icon="ChevronRightIcon"
            />
          </span> {{ title }}
        </h4>
        <slot
          v-if="visible"
          name="header-action"
        />
      </div>
    </b-card-header>

    <b-collapse
      :id="collapseItemID"
      v-model="visible"
      :accordion="accordion"
      role="tabpanel"
    >
      <b-card-body class="py-0">
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCollapse,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    hideDropdownIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      collapseItemID: '',
      openOnHover: this.$parent.hover,
    }
  },
  computed: {
    accordion() {
      return this.$parent.accordion ? `accordion-${this.$parent.collapseID}` : null
    },
  },
  created() {
    this.collapseItemID = uuidv4()
    this.visible = this.isVisible
  },
  methods: {
    updateVisible(val = true) {
      this.visible = val
      this.$emit('visible', val)
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true)
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false)
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown {
  font-size: 1.7rem;
}

.dropdown svg {
  transform: scale(1.3);
}
.dropdown .open {
  transform: rotate(90deg) scale(1.3);
  transition: 250ms ease-in;
}
</style>
